'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/card/style/css.js
// module id = dYkR
// module chunks = 0